<template>
    <div id="detail-wrapper">
        <check-adult :isAdult="isAdult()" />
        <div id="detail-container">
            <div class="container-lg">
                <list-breadcrumb :breadcrumbs="breadcrumbs"></list-breadcrumb>
                
                <h2 class="detail-page-title">{{p_item.title}}</h2>

                <div class="row">
                    <div class="detail-col-image">
                        <div class="detail-main-image" :style="{ height: detailMainImageHeight + 'px' }">
                            <img :src="p_item.mainImage" @click="openShowLightBox"/>
                          <img src="/images/icons/caution.png" alt="注意" class="caution-icon" v-if="p_item.is_caution" />
                        </div>
                        <div class="detail-sub-images-container">
                            <div class="detail-sub-image" v-for="(subImage, index) in p_item.subImages"  :style="{ width: detailSubImageWidth + 'px', height: detailSubImageHeight + 'px' }" @click="selectSubImage(subImage)" :key="`subImage${index}`">
                                <img :src="subImage" v-if="subImage"/>
                            </div>
                        </div>
                    </div>
                    <div class="detail-col-content">
                        <div class="detail-container">
                            <div class="detail-content">
                                
                                <div v-if="p_item.orderItemsLength > 0" class="detail-content-sub-container">
                                    <span class="badge badge-danger">SoldOut</span>
                                </div>
                                    <span v-if="p_item.isAdult" class="badge badge-danger ml-3">成人向け</span>
                                <div class="detail-content-sub-container">
                                    <span class="detail-content-span">商品番号</span>
                                    <p class="detail-content-text">{{ p_item.id }}</p>
                                </div>

                                <div class="detail-content-sub-container" v-if="p_item.bigCategory">
                                  <span class="detail-content-span">ジャンル</span>
                                  <div class="detail-content-category">
                                    <a :href="p_item.bigCategory.href" class="detail-content-link">{{ p_item.bigCategory.text }}</a>
                                  </div>
                                </div>

                                <div class="detail-content-sub-container">
                                    <span class="detail-content-span">カテゴリー</span>
                                    <div class="detail-content-category">
                                        <a :href="p_item.mainCategory.href" class="detail-content-link">{{ p_item.mainCategory.text }}</a>
                                        <a :href="p_item.subCategory.href" class="detail-content-link">{{ p_item.subCategory.text }}</a>
                                    </div>
                                </div>

                                <div class="detail-content-sub-container">
                                    <span class="detail-content-span">種別</span>
                                    <p class="detail-content-text">{{ p_item.itemType }}</p>
                                </div>

                                <div class="detail-content-sub-container">
                                    <span class="detail-content-span">商品の状態</span>
                                    <p class="detail-content-text">{{ p_item.itemState }}</p>
                                </div>

                                <div class="detail-content-sub-container">
                                    <span class="detail-content-span">配送料の負担</span>
                                    <p class="detail-content-text">{{ p_item.itemDeliveryType }}</p>
                                </div>

                                <div class="detail-content-sub-container">
                                    <span class="detail-content-span">配送方法</span>
                                    <p class="detail-content-text">{{ p_item.itemDeliveryMethod }}</p>
                                </div>

                                <div class="detail-content-sub-container">
                                    <span class="detail-content-span">発送元の地域</span>
                                    <p class="detail-content-text">{{ p_item.itemDeliveryPrefecture }}</p>
                                </div>

                                <div class="detail-content-sub-container">
                                    <span class="detail-content-span">サブジャンル（創作元・原作名）</span>
                                    <p class="detail-content-text">{{ p_item.ganreName }}</p>
                                </div>

                                <div class="detail-content-sub-container">
                                    <span class="detail-content-span">カップリングまたはメインキャラ</span>
                                    <p class="detail-content-text">{{ p_item.itemCoupling }}</p>
                                </div>

<!--                                <div class="detail-content-sub-container">-->
<!--                                    <div class="detail-content-review">-->
<!--                                        <div class="detail-rating-container">-->
<!--                                            <p class="rating">-->
<!--                                                <i class="icon-good"></i><label>良かった（<a :href="p_item.reviewsUrl" class="detail-content-link">{{p_item.goodCount}}</a>）</label>-->
<!--                                                <i class="icon-bad"></i><label>残念だった（<a :href="p_item.reviewsUrl" class="detail-content-link">{{p_item.badCount}}</a>）</label>-->
<!--                                            </p>-->
<!--                                        </div>-->
<!--                                        <a href="javascript:void(0)" class="detail-content-link" @click="goto('refReviews')" v-if="p_item.purchased">レビューを書く</a>-->
<!--                                    </div>-->
<!--                                </div>-->
                            </div>

                            <div class="detail-seller-desc-container">
                              <div class="detail-seller-desc" v-bind:class="{'detail-seller-minimize-desc' : detailSellerDescriptionMin}" ref="detail_seller_desc" v-html="p_item.description"></div>

                              <div class="detail-seller-desc-more-link" v-if="havingSellerDescriptionMin && detailSellerDescriptionMin && p_item.description">
                                <a href="javascript:void(0)" @click="openSellerDescription">続きを読む</a>
                                <span class="more-link-icon"></span>
                              </div>

                              <div class="detail-seller-desc-more-link" v-if="havingSellerDescriptionMin && detailSellerDescriptionMin == false && p_item.description">
                                <a href="javascript:void(0)" @click="closeSellerDescription">隠す</a>
                                <span class="less-link-icon"></span>
                              </div>
                            </div>

                            <div class="detail-price">
                                <p>{{ p_item.price }}<span>(税込)</span></p>
                            </div>

                            <div class="detail-actions">
                                <div class="row">
                                    <div class="col-lg-12 col-xl-6">
                                        <a href="javascript:void(0)" :disabled="p_item.orderItemsLength > 0" @click="cartItem" class="btn detail-cart-button" :class="{ 'disabled btn-secondary': p_item.orderItemsLength > 0 }"><i></i>{{p_item.orderItemsLength > 0 ? '売り切れ' : 'カートにいれる'}}</a>
                                    </div>
                                    <div class="col-lg-12 col-xl-6">
                                        <div class="row">
                                            <div class="col-6">
                                                <a href="javascript:void(0)" @click="favoriteItem" class="detail-actions-link detail-action-link-favorite" v-if="p_item.favorited == false"><span class="detail-action-span-favorite">お気に入り<br>に追加する</span></a>
                                                <a href="javascript:void(0)" @click="favoriteItem" class="detail-actions-link detail-action-link-favorite" v-if="p_item.favorited"><span class="detail-action-span-favorite">お気に入り<br>に追加済み</span></a>
                                            </div>


                                            <div class="col-6">
                                                <a :href="p_item.buyPointUrl" class="detail-actions-link detail-action-link-point"><span class="detail-action-span-point">ポイント購入</span></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="detail-seller">
                                <div class="detail-seller-links">
                                    <span>▶︎ <a href="javascript:void(0)" @click="sendNewMessage" class="detail-seller-link">この商品について問い合わせる</a></span>
                                    <span>▶︎ <a href="javascript:void(0)" @click="concernMessage" class="detail-seller-link">「気になる」を出品者に通知</a></span>
                                    <a href="javascript:void(0);" @click="twitterOpen" class="detail-seller-sns-link"><img src="/images/icons/twitter.svg" /></a>
                                </div>

                                <div class="detail-seller-block">
                                    <h3 class="detail-seller-block-title">出品者情報</h3>
                                    <div class="row">
                                        <div class="col-4 col-lg-2">
                                            <div class="detail-seller-block-image-container">
                                                <a :href="p_item.sellerUrl"><img :src="p_item.sellerImg"/></a>
                                            </div>
                                        </div>
                                        <div class="col-8 col-lg-6">
                                            <div class="detail-seller-block-content">
                                                <h3 class="detail-seller-block-content-title">
                                                  <a :href="p_item.sellerUrl">{{ p_item.sellerName }} <span v-if="p_item.sellerIsIdentifyConfirmed">✅<span class="small-txt">（本人情報確認済み）</span></span></a>
                                                </h3>
                                                <p class="detail-seller-block-content-level">{{ p_item.sellerLevel }}</p>
                                                <div class="detail-seller-block-content-rating">
                                                    <div class="detail-rating-container">
                                                        <p class="rating">
                                                            <i class="icon-good"></i><label style="margin-left: 4px; margin-right: 16px"><a :href="p_item.sellerReviewsUrl" class="detail-content-link text-sm">良かった({{p_item.sellerGoodCount}})</a></label>
                                                            <i class="icon-bad"></i><label style="margin-left: 4px; margin-right: 16px"><a :href="p_item.sellerReviewsUrl" class="detail-content-link text-sm">残念だった({{p_item.sellerBadCount}})</a></label>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-lg-4" style="padding-left: 0">
                                            <a href="javascript:void(0)" @click="followUser" class="detail-seller-follower-button" v-if="p_item.following == false">
                                                <i></i>
                                                ＋フォローする
                                            </a>

                                            <a href="javascript:void(0)" @click="followUser" class="detail-seller-follower-button"
                                               v-if="p_item.following">
                                                <i></i>
                                                ＋フォロー済み
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <div class="detail-seller-product-link">
                                  <a :href="`/item/report/${p_item.id}`">商品を通報する</a>
                                  <a :href="p_item.sellerListUrl">このユーザーの他の商品を見る</a>
                                </div>
                              
                              <!-- Modal -->
<!--                              <div class="modal fade adult_modal" id="reportModal" tabindex="-1" role="dialog" aria-labelledby="reportModal">-->
<!--                                <div class="modal-dialog modal-dialog-centered" role="document">-->
<!--                                  <div class="modal-content">-->
<!--                                    <div class="modal-header adult_modal&#45;&#45;caption pt-5">-->
<!--                                      <h3 class="modal-title">年齢確認</h3>-->
<!--                                    </div>-->
<!--                                    <div class="modal-body">-->
<!--                                      <h5 class="adult_modal&#45;&#45;title pb-1">-->
<!--                                        あなたは18歳以上ですか？-->
<!--                                      </h5>-->
<!--                                      <p class="adult_modal&#45;&#45;content">-->
<!--                                        ここから先は、アダルト商品の詳細ページです。<br />-->
<!--                                        18歳未満の方のアクセスは固くお断りします。-->
<!--                                      </p>-->
<!--                                    </div>-->
<!--                                    <div class="modal-footer adult_modal&#45;&#45;footer pb-4 pt-0">-->
<!--                                      <button type="button" class="btn px-5 btn-secondary" @click="notAgree">いいえ</button>-->
<!--                                      <button type="button" class="btn px-5 btn-primary" @click="agree">はい</button>-->
<!--                                    </div>-->
<!--                                  </div>-->
<!--                                </div>-->
<!--                              </div>-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="detail-relation-container">
            <div class="container-relation" ref="list_page_wrapper" >
                <div class="container-inner-relation" :style="{ width: suggestWidth + 'px' }">
                    <div class="detail-section-item">
                        <h2>
                            一緒に買われています
                            <span class="detail-section-item-link"><a :href="p_item.productUrl1">もっと見る</a></span>
                        </h2>

                        <div class="product-items-container">
                            <product-item v-for="(r_product, index) in r_products" :item="r_product" :key="index"></product-item>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="detail-relation-container even">
            <div class="container-relation">
                <div class="container-inner-relation" :style="{ width: suggestWidth + 'px' }">
                    <div class="detail-section-item">
                        <h2>
                            この出品者の人気商品
                            <span class="detail-section-item-link"><a :href="p_item.productUrl2">もっと見る</a></span>
                        </h2>

                        <div class="product-items-container">
                            <product-item v-for="(s_product, index) in s_products" :item="s_product" :key="index"></product-item>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="detail-relation-container">
            <div class="container-relation">
                <div class="container-inner-relation" :style="{ width: suggestWidth + 'px' }">
                    <div class="detail-section-item">
                        <h2>
                            最近閲覧した商品
                            <span class="detail-section-item-link"><a :href="p_item.productUrl3">もっと見る</a></span>
                        </h2>
                        <div class="product-items-container">
                            <product-item v-for="(l_product, index) in l_products" :item="l_product" :key="index"></product-item>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                </div>
            </div>
        </div>

        <vue-image-lightbox-carousel
                ref="lightbox"
                :show="showLightbox"
                @close="showLightbox = false"
                :images="images"
                :showCaption="false"
        >
        </vue-image-lightbox-carousel>

        <to-top></to-top>
    </div>
</template>

<script>
    import VueImageLightboxCarousel from 'vue-image-lightbox-carousel'
    import CheckAdult from './CheckAdult'

    export default {
        props: ['breadcrumbs', 'product', 'relationproducts', 'sellerproducts', 'lastbrowseproducts'],
        components: {
            VueImageLightboxCarousel,
            CheckAdult
        },
        data() {
            return {
                suggestWidth: null,
                detailMainImageHeight: null,
                detailSubImageWidth: null,
                detailSubImageHeight: null,
                p_item: JSON.parse(this.product),
                r_products: JSON.parse(this.relationproducts),
                s_products: JSON.parse(this.sellerproducts),
                l_products: JSON.parse(this.lastbrowseproducts),
                detailSellerDescriptionMin: false,
                havingSellerDescriptionMin: false,
                commentRating: 0,
                itemsDisplay: 0,
                commentText: '',
                windowWidth: 0,
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                showLightbox: false,
                images: [],
            }
        },
        mounted() {
            this.handleResize();
            this.handleImages();
        },
        methods: {
            openShowLightBox() {
                this.showLightbox = true;
            },
            goto(refName) {
                var element = this.$refs[refName];
                var top = element.offsetTop;

                window.scrollTo({top: top, behavior: 'smooth'});
            },
            selectSubImage(subImage) {
                if (subImage) {
                    this.p_item.mainImage = subImage;
                }
            },
            openSellerDescription() {
                this.detailSellerDescriptionMin = false;
            },
            closeSellerDescription() {
                this.detailSellerDescriptionMin = true;
            },
            handleImages() {
                // this.images.push({path: this.p_item.mainImage});
                for (var i in this.p_item.subImages) {
                    var subImage = this.p_item.subImages[i];
                    this.images.push({path: subImage});
                }
            },
            handleResize() {

                let detailMainImageWidth = $('.detail-main-image').width();
                if (detailMainImageWidth) {
                    this.detailMainImageHeight = detailMainImageWidth / 3 * 2;
                    this.detailSubImageWidth = (detailMainImageWidth - 32) / 5;
                    this.detailSubImageHeight = this.detailSubImageWidth / 3 * 2;
                }

                if (this.$refs.detail_seller_desc && (window.innerWidth != this.windowWidth)) {
                    this.windowWidth = window.innerWidth;
                    this.openSellerDescription();
                    let detail_seller_desc_height = this.$refs.detail_seller_desc.clientHeight;
                    if (detail_seller_desc_height > 37) {
                        this.detailSellerDescriptionMin = true;
                        this.havingSellerDescriptionMin = true;
                    } else {
                        this.detailSellerDescriptionMin = false;
                        this.havingSellerDescriptionMin = false;
                    }
                }


                let window_width = window.innerWidth;
                if (this.$refs.list_page_wrapper) {
                    if (window_width >= 768) {
                        let wrapper_width = this.$refs.list_page_wrapper.clientWidth;

                        let iWidth = 210;
                        let suggestWidth = iWidth;
                        for (var i = 1; i < 100; i++) {
                            iWidth = 195 * i + 210;
                            if (iWidth > wrapper_width) break;
                            suggestWidth = iWidth;
                        }
                        this.suggestWidth = suggestWidth;
                        this.itemsDisplay = i;

                    } else {
                        let wrapper_width = this.$refs.list_page_wrapper.clientWidth;
                        this.suggestWidth = wrapper_width;
                        this.itemsDisplay = 2;
                    }
                }


            },
            cartItem () {
                if (this.p_item.orderItemsLength > 0) {
                    this.$swal('', 'すでに販売された商品です。', 'warning')
                    return;
                }
                // if (!this.p_item.planed) {
                //     this.$swal({
                //         text: 'プラン購入しないと購入できません。',
                //         buttons: true,
                //         icon: "warning",
                //         confirmButtonText: "プランを選択する",
                //         cancelButtonText: "キャンセル",
                //         confirmButtonColor: "#DD6B55",
                //         dangerMode: true,
                //         buttons: ['キャンセル', 'プランを選択する']
                //     }).then((confirmed) => {
                //         if (confirmed) {
                //             window.location.href="/mypage/plans"
                //         } else {
                //         }
                //     })
                // } else {
                    if (this.p_item.user_id == this.p_item.sellerId) {
                        alert('自分の商品は購入できません');
                    } else {
                        if (this.p_item.status == 0) {
                            alert('一時停止された商品です。販売者にお問い合わせください');
                        } else {
                            location.href = this.p_item.cartUrl;
                        }
                    }
                //}
            },
            favoriteItem() {
                let data = {};
                data.user_id = this.p_item.user_id;
                data.item_id = this.p_item.id;
                axios.post('/item/favorite', data)
                    .then(response => {
                        let status = response.data.status;
                        if (status == 0) {
                            alert('お気に入りに登録しました。');
                            this.p_item.favorited = true;
                        } else if (status == -1 || status == -2) {
                            alert('お気に入りに登録失敗しました。');
                        } else if (status == -3) {
                            alert('お気に入りにから解除しました。');
                            this.p_item.favorited = false;
                        } else if (status == -4) {
                            alert('自分の商品をお気に入りに登録できません。');
                        } else if (status == -5) {
                            alert('ログインしてください。');
                        }
                    })
            },
            followUser() {
                let data = {};
                data.user_id = this.p_item.user_id;
                data.follow_user_id = this.p_item.sellerId;
                axios.post('/item/follow', data)
                    .then(response => {
                        let status = response.data.status;
                        if (status == 0) {
                            alert('フォローしました。');
                            this.p_item.following = true;
                        } else if (status == -1) {
                            alert('自分をフォローできません。');
                        } else if (status == -2) {
                            alert('フォローするためにはログインが必要です。');
                        } else if (status == -3) {
                            alert('フォロー解除しました。');
                            this.p_item.following = false;
                        }
                    })
            },
            twitterOpen() {
                window.open(this.p_item.twitterUrl, this.p_item.twitterSetting, 0);
            },
            sendNewMessage() {
                if (this.p_item.user_id == this.p_item.sellerId) {
                    alert('自分にはメッセージを送信できません。');
                } else {
                    location.href=this.p_item.newMessageUrl;
                }
            },
            concernMessage() {
                if (this.p_item.user_id == this.p_item.sellerId) {
                    alert('自分にはメッセージを送信できません。');
                } else {
                    location.href=this.p_item.concernUrl;
                }
            },
            review() {
                if (this.p_item.user_id == 0) {
                    alert('レビューするためにはログインが必要です。');
                } else {
                    if (this.commentRating == 0) {
                        alert('評価を選択してください');
                        return;
                    }
                    if (this.commentText == '') {
                        alert('コメントを入力してください');
                        return;
                    }

                    $('#reviewForm').submit();
                }

            },
            isAdult () {
                return this.p_item.checkAdult;
            }
        },
        created() {
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize);
        },
    }
</script>

<style>
    #detail-container {
        padding-top: 60px;
        padding-bottom: 40px;
    }

    @media (max-width: 768px) {
        #detail-container {
            padding-top: 20px;
        }
    }

    .detail-page-title {
        font-size: 27px;
        margin-bottom: 30px;
    }

    @media (max-width: 768px) {
        .detail-page-title {
            font-size: 22px;
            margin-bottom: 10px;
        }
    }

    .detail-main-image {
        width: 100%;
        background-color: #E6E6E6;
        position: relative;
        margin-bottom: 16px;
    }

    .detail-main-image img {
        position: absolute;
        top: 50%; left: 50%;
        transform: translate(-50%, -50%);
        max-width: 100%;
        max-height: 100%;
        height: auto;
        cursor: zoom-in;
    }

    .detail-sub-images-container {
        margin-right: -8px;
        margin-bottom: 16px;
    }

    .detail-sub-image {
        float: left;
        margin-right: 8px;
        position: relative;
        background-color: #E6E6E6;
        margin-bottom: 8px;
    }

    .detail-sub-image img {
        position: absolute;
        top: 50%; left: 50%;
        transform: translate(-50%, -50%);
        max-width: 100%;
        height: auto;
        max-height: 100%;
    }

    .detail-sub-image img:hover {
        cursor: pointer;
    }

    .detail-content {
        margin-top: 6px;
        margin-bottom: 30px !important;
    }

    @media (max-width: 768px) {
        .detail-content {
            margin-bottom: 20px;
        }
    }

    .detail-content-sub-container {
        margin-bottom: 20px;
    }
    .detail-content-span {
        font-size: 12px;
        padding: 4px 12px;
        background-color: #F5F5F5;
        border: 1px solid #B3B3B3;
        border-radius: 16px;
        color: #333333;
    }

    .detail-content-text {
        font-size: 15px;
        margin-top: 10px;
        color: #666666;
    }

    .detail-content-link {
        font-size: 12px;
        color: #666666;
        text-decoration: underline;
    }

    .detail-content-link:hover {
        text-decoration: none;
        color: #666666;
    }

    .detail-content-link:visited {
        color: #666666;
    }

    .detail-content-category {
        margin-top: 10px;
    }

    .detail-content-category .detail-content-link+.detail-content-link {
        margin-left: 16px;
    }

    .detail-content-review .detail-content-link{
        font-size: 13px;
    }

    .detail-rating-container {
        float: left;
        margin-top: -2px;
    }

    .detail-price {
        margin-bottom: 16px;
    }

    .detail-price p {
        font-size: 30px;
    }

    .detail-price span {
        font-size: 17px;
        margin-left: 3px;
    }

    .detail-cart-button {
        width: 100%;
        height: 54px;
        color: #ffffff;
        background-color: #F08C1E;
        border-radius: 3px;
        font-size: 18px;
        display: block;
        padding: 12px;
        text-align: center;
        margin-bottom: 20px;
        text-decoration: none;
    }

    .detail-cart-button:hover, .detail-cart-button:visited {
        color: #ffffff;
        text-decoration: none;
        opacity: 0.5;
    }

    .detail-cart-button i {
        background-image: url(/images/icons/cart.svg);
        width: 24px;
        height: 24px;
        display: inline-block;
        background-repeat: no-repeat;
        background-position: center center;
        margin-right: 8px;
        overflow: hidden;
        vertical-align: sub;
    }

    .detail-actions {
        margin-bottom: 30px;
    }

    .detail-actions-link {
        background-color: #FCFCFC;
        border: 1px solid #B3B3B3;
        border-radius: 30px;

        display: inline-block;
        font-size: 13px;
        height: 54px;
        width: 127px;
        padding-left: 36px;
    }

    .detail-actions-link, .detail-actions-link:visited {
        color: #333333;
        text-decoration: none;
    }

    .detail-actions-link:hover {
        color: #333333;
        text-decoration: none;
        opacity: 0.5;
    }

    .detail-action-span-favorite {
        display: inline-block;
        line-height: 15px;
        padding-top: 12px;
    }

    .detail-action-span-point {
        display: inline-block;
        line-height: 18px;
        padding-top: 18px;
    }

    .detail-action-link-favorite {
        background-image: url("/images/icons/list2.svg");
        background-size: 18px 18px;
        background-repeat: no-repeat;
        background-position: 13px 18px;
    }

    @media (max-width: 1200px) {
        .detail-action-link-favorite {
            float: right;
        }
    }

    .detail-action-link-point {
        background-image: url("/images/icons/point2.svg");
        background-size: 18px 18px;
        background-repeat: no-repeat;
        background-position: 12px 18px;
        /*margin-left: 12px;*/
    }

    .detail-seller-links {
        margin-bottom: 22px;
    }

    .detail-seller-link {
        font-size: 14px;
        margin-right: 28px;
        text-decoration: underline;
    }

    @media (max-width: 1200px) {
        .detail-seller-links {
            font-size: 12px;
        }
        .detail-seller-link {
            font-size: 12px;
            margin-right: 18px;
        }
    }

    .detail-seller-link, .detail-seller-link:hover, .detail-seller-link:visited {
        color: #666666;
    }

    .detail-seller-link:hover {
        text-decoration: none;
    }

    .detail-seller-sns-link img {
        width: 22px; height: 22px;
    }

    .detail-seller-block {
        background-color: #F5F5F5;
        border-radius: 3px;
        padding: 20px 27px;
        margin-bottom: 12px;
    }

    .detail-seller-block-title {
        font-size: 13px;
        margin-bottom: 10px;
    }

    .detail-seller-block-image-container {
        text-align: center;
    }
    .detail-seller-block-image-container img {
        /*width: 100%;*/
        border-radius: 50%;
        /*min-width: 64px;*/
        width: 64px;
        height: 64px;
        object-fit: cover;
    }

    .detail-seller-block-content-title {
        font-size: 18px;
        margin-bottom: 12px;
        overflow: hidden;
        display: block;
        -webkit-line-clamp: 1;
        word-break: break-word;
        text-overflow: ellipsis;
        display: -webkit-box;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
    }

    .detail-seller-block-content-title a {
        color: black;
    }

    .detail-seller-block-content-level {
        font-size: 12px;
        margin-bottom: 8px;
    }

    .detail-seller-block-link {
        font-size: 13px;
        color: #666666;
        text-decoration: underline;
    }

    .detail-seller-block-link:hover {
        text-decoration: none;
        color: #666666;
    }

    .detail-seller-block-link:visited {
        color: #666666;
    }

    .detail-seller-follower-button {
        margin-top: 12px;
        font-size: 13px;
        color: #333333;
        line-height: 17px;
        padding-top: 11px;
        padding-bottom: 11px;
        background-color: #ffffff;
        border: 1px solid #B3B3B3;
        border-radius: 30px;
        width: 100%;
        display: inline-block;
        text-align: center;
        min-width: 140px;
        text-decoration: none;
    }

    .detail-seller-follower-button:hover {
        color: #333333;
        text-decoration: none;
        opacity: 0.5;
    }

    .detail-seller-follower-button:visited {
        color: #333333;
    }

    .detail-seller-follower-button i {
        background-image: url("/images/icons/user.svg");
        width: 15px;
        height: 15px;
        display: inline-block;
        vertical-align: sub;
        background-repeat: no-repeat;
    }

    .detail-seller-product-link {
        text-align: right; font-size: 15px;
        margin-bottom: 30px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }

    .detail-seller-product-link a {
        color: #333333; text-decoration: underline;
    }

    .detail-seller-product-link a:hover, .detail-seller-product-link a:visited {
        color: #333333;
    }

    .detail-seller-product-link a:hover {
        text-decoration: none;
    }

    .detail-seller-desc {
        color: #333333;
        font-size: 16px !important;
        padding: 0 6px;
        line-height: 18px;
        margin-bottom: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        /*white-space: pre;*/
    }

    .detail-seller-minimize-desc {
        height: 36px;
        -webkit-line-clamp: 2;
    }

    .detail-seller-desc-more-link {
        text-align: right;
        position: relative;
        padding-right: 18px;
    }

    .detail-seller-desc-more-link a, .detail-seller-desc-more-link a:hover, .detail-seller-desc-more-link a:visited {
        color: #333333; text-decoration: none;
    }
    .more-link-icon {
        display: block;
        position: absolute;
        top: 8px;
        right: 0;
        bottom: 0;
        width: 8px;
        height: 8px;
        border-right: 2px solid #363636;
        border-bottom: 2px solid #363636;
        transform: translateY(-2px) rotate(45deg);
        transition: transform 0.2s ease;
    }

    .less-link-icon {
        display: block;
        position: absolute;
        top: 11px;
        right: 0;
        bottom: 0;
        width: 8px;
        height: 8px;
        border-right: 2px solid #363636;
        border-bottom: 2px solid #363636;
        transform: translateY(-2px) rotate(-135deg);
        transition: transform 0.2s ease;
    }

    .detail-seller-desc-container {
        margin-bottom: 30px 5px;
        border: 1px solid #E3E3E3;
        padding: 10px;
    }

    .detail-seller-review-container {
        color: #333333;
    }

    .detail-seller-review-title {
        font-size: 16px; margin-bottom: 16px;
    }

    .detail-seller-review-rating {
        margin-bottom: 12px;
    }
    .detail-seller-review-rating label {
        font-size: 13px; margin-left: 12px;
    }

    .detail-seller-review-comment-title {
        font-size: 13px; margin-bottom: 12px;
    }

    .detail-seller-review-comment-button {
        text-align: right; padding-right: 16px;
        margin-top: 15px;
    }

    .detail-seller-review-comment-button input[type=submit] {
        border-radius: 3px;
        font-size: 16px;
        line-height: 20px;
        padding: 9px;
        background-color: #F9F9F9;
        border: 1px solid #B3B3B3;
        color: #333333;

    }

    .detail-relation-container {
        padding: 50px 0;
        background: transparent;
    }

    .detail-relation-container.even {
        background-color: #F7F7F7;
    }


    .detail-section-item {
        padding-left: 15px;
    }

    .detail-section-item h2 {
        font-size: 22px;
        margin-bottom: 12px;
        overflow: hidden;
    }

    @media (max-width: 768px) {
        .detail-section-item {
            margin-bottom: 40px;
            overflow: hidden;
            padding-bottom: 5px;
            border-bottom: 1px solid #B3B3B3;
            padding-left: 8px;
            padding-right: 8px;
        }

        .detail-section-item:last-child {
            border-bottom: none;
        }

        .detail-section-item h2 {
            font-size: 16px;
        }
    }

    .detail-section-item h2 span.detail-section-item-link {
        float: right;
        font-size: 16px;
        margin-top: 8px;
        margin-right: 30px;
    }

    .detail-section-item h2 span.detail-section-item-link a {
        color: #000;
        text-decoration: underline;
    }

    .detail-section-item h2 span.detail-section-item-link a:hover,
    .detail-section-item h2 span.detail-section-item-link a:visited {
        color: #000;
    }

    .detail-section-item h2 span.detail-section-item-link a:hover {
        text-decoration: none;
    }



    @media (max-width: 768px) {
        .detail-section-item h2 span.detail-section-item-link {
            margin-right: 18px;
            margin-top: 5px;
            font-size: 13px;
        }

        .detail-section-item h2 span.detail-section-item-link a {
            text-decoration: none;
        }

        .detail-section-item h2 span.detail-section-item-link a:after {
            content: '>';
            margin-left: 8px;
            font-size: 13px;
        }
    }

    .container-relation {
        width: 100%;
        margin-left: auto;
        margin-right: auto;
        overflow: hidden;
    }

    @media (min-width: 1400px) {
        .container-relation {
            max-width: 1380px;
        }
    }

    .container-inner-relation {
        margin-left: auto;
        margin-right: auto;

    }

    #detail-wrapper {
        padding-bottom: 250px;
        position: relative;
    }

    @media (max-width: 768px) {
        #detail-wrapper {
            padding-bottom: 100px;
        }
    }
    .detail-col-image {
        width: 583px;
    }

    .detail-col-content {
        width: 543px;
        padding-left: 30px;
    }


    @media (max-width: 1200px) {
        .detail-col-image {
            width: 497px;
        }

        .detail-col-content {
            width: 462px;
            padding-left: 20px;
        }
    }

    .caution-icon {
      width: 100px;
      top: 85% !important;
      left: 85% !important;
    }

    @media (max-width: 992px) {
        .detail-col-image {
            width: 55%;
            padding-left: 15px;
            padding-right: 15px;
        }

        .detail-col-content {
            width: 45%;
            padding-left: 15px;
            padding-right: 15px;
        }
    }

    @media (max-width: 768px) {
        .detail-col-image {
            width: 100%;
            padding-left: 15px;
            padding-right: 15px;
        }

        .detail-col-content {
            width: 100%;
            padding-left: 15px;
            padding-right: 15px;
        }
    }
</style>